module.exports = __webpack_public_path__ + "static/img/ARAD3S_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD3S_2.png
// module id = at7Y
// module chunks = 0